// src/index.ts
function clickOutside(node, handler) {
  let pointerDownStartedInside = false;
  const onPointerDown = (event) => {
    if (!event.defaultPrevented && (node == null ? void 0 : node.contains(event.target))) {
      pointerDownStartedInside = true;
    }
  };
  const onPointerUp = (event) => {
    if (!event.defaultPrevented && !pointerDownStartedInside && node && !node.contains(event.target)) {
      handler();
    }
    pointerDownStartedInside = false;
  };
  document.addEventListener("pointerup", onPointerUp, true);
  document.addEventListener("pointerdown", onPointerDown, true);
  return {
    destroy() {
      document.removeEventListener("pointerup", onPointerUp, true);
      document.removeEventListener("pointerdown", onPointerDown, true);
    }
  };
}
export {
  clickOutside
};
//# sourceMappingURL=index.js.map